// extracted by mini-css-extract-plugin
export default {"sortable-column":"NeighborsTable_sortable-column__Zk8mC","sort-icon":"NeighborsTable_sort-icon__HIad1","header-content":"NeighborsTable_header-content__ibD7T"};